export default __webpack_public_path__ + "static/media/LogoLight.168d172d.svg";